export class ErrorObject {
    constructor(public message?: string, public context?: any) {}
}
